import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'src/app/core/data/service/http.service';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { AiHelperComponent } from 'src/app/shared/modal/ai-helper/ai-helper.component';
import { SupportRequest } from '../schema/support/support-request';
import { Log } from 'src/app/core/log';

@Injectable({
  providedIn: 'root'
})
export class AiService extends HttpService {

  constructor(
    http: HttpClient,
  ) {
    super(http);
    this.endpoint = `${this.apiURL}/test`;
  }

  async submitTicket(files: FileList, ticket: SupportRequest) : Promise<any>{
    const url = `${this.apiURL}/support`;
    const formData = new FormData();

    // attach files
    if ( files != null ) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }
    }

    // set each property of ticket on form data
    Object.keys(ticket).forEach(key => {
      formData.append(key, ticket[key]);
    });

    return await this.upload(formData, url, 'json');
  }

  async submitAudioPrompt(blob: Blob, imageMode: boolean, messageHistory: any) : Promise<string>{
    const url = `${this.apiURL}/ai/prompt`;
    const formData = new FormData();
    formData.append('file', blob, 'test.ogg');
    formData.append('isSearch', 'false');
    formData.append('searchAll', 'false');
    formData.append('isImage', imageMode.toString());
    // formData.append('messageHistory', messageHistory);
    return <string>( await this.upload(formData, url));
  }

  async submitPrompt(prompt: string, imageMode: boolean, messageHistory: any) : Promise<string>{
    const url = `${this.apiURL}/ai/prompt`;
    const formData = new FormData();
    //formData.append('file', undefined, 'test.ogg');
    formData.append('newPrompt', prompt);
    formData.append('isSearch', 'false');
    formData.append('searchAll', 'false');
    formData.append('isImage', imageMode.toString());
    // formData.append('messageHistory', messageHistory);
    return <string>( await this.upload(formData, url));
  }

  async upsizeImage(imgB64: string) : Promise<string>{
    const url = `${this.apiURL}/ai/upsize`;
    const formData = new FormData();
    formData.append('base64ToUpsize', imgB64);
    return <string>( await this.upload(formData, url));
  }

  protected isUpdate(entity: any): boolean {
    throw new Error('Method not implemented.');
  }
  protected getUpdateUrl(entity: any): string {
    throw new Error('Method not implemented.');
  }

  // pass in object and property to apply the generated text to
  static async openAi(obj: any, prop: string, imageGen: boolean = false, title: string = null, desc: string = null) {
    
    var aiModal = await ServiceHelper.modalCtrl.create({
      component: AiHelperComponent,
      cssClass: 'ai-modal', // argh!!! why you no worky?!
      componentProps: {
        imageMode: imageGen,
        prompt: (title != null ? title + (desc != null ? ' ' : '') : '') + ' ' + (desc != null ? desc : '')
      }
    });
    await aiModal.present();
    Log.debug('ai openened, waiting for dismissal...')
    aiModal.onDidDismiss().then(e => {
      if (e.data != null && imageGen == false && e.data.answer != null) {
        obj[prop] = e.data.answer;
      } else if (e.data != null && imageGen == true && e.data.imageBase64 != null) {
        obj[prop] = e.data.imageBase64;
      }
    });
  }

}


// export class Upload {

//   mimeType: string;
//   thumbPath: string | SafeResourceUrl;
//   safeUrl: string | SafeResourceUrl;
//   videoSources: VideoSource[] = [];
//   isBase64 = false;
//   isEmbedVideo = false;
//   isImage = false;
//   isBlob = false;
//   isDoc = false;
//   description: string;
//   filename: string;
//   isVideo = false;

//   constructor(public path?: string) {
//       if (path == null) {
//           return;
//       }

//       if (path.startsWith('data')) {
//           this.parseBase64(path);
//       } else if (path.startsWith('blob')) {
//           this.isBlob = true;
//       } else {


//           const imageTypes = ['jpeg', 'png', 'gif', 'bmp', 'webp'];
//           const videoTypes = ['mp4', 'mpeg', 'avi', 'mkv'];
//           const docTypes = ['docx', 'pdf', 'txt', 'doc', 'zip', 'xlsx', 'csv'];
//           const extension = path.split('.').pop().toLowerCase();

//           if (imageTypes.indexOf(extension) > -1) {
//               this.mimeType = `image/`;
//           } else if (videoTypes.indexOf(extension) > -1) {
//               this.mimeType = `video/`;
//           } else if (docTypes.indexOf(extension) > -1) {
//               this.mimeType = `application/`;
//           }

//           this.mimeType += extension;
//           this.safeUrl = path;

//           this.testType();

//           // if it's an mp4 video and it's from the API add an alt
//           if (this.isVideo && this.mimeType === 'video/mp4' && this.path.includes('cdn.bidbeacon')) {
//               // Add the webm version
//               const webm = this.path.replace('.mp4', '.webm');
//               const altSource = new VideoSource({
//                   filePath: webm,
//                   safeUrl: webm,
//                   mimeType: 'video/webm',
//                   fileName: Utilities.generateUuidv4() + '.webm'
//               });
//               this.videoSources.push(altSource);
//           }
//       }

//       // Set the thumbnail, would be good to have real ones
//       this.thumbPath = path;

//       Log.debug(this);
//   }

//   testType() {
//       if (this.mimeType.includes('image')) {
//           this.isImage = true;
//       } else if (this.mimeType.includes('video')) {
//           this.isVideo = true;
//       } else if (this.mimeType.includes('application')) {
//           this.isDoc = true;
//       } else {
//           this.isEmbedVideo = (this.isImage === false && this.isDoc === false && this.isVideo === false && this.isBlob === false);
//       }
//   }

//   async getBase64() {
//       return await Utilities.getBase64FromDataUrl(this.path);
//   }

//   async getBlob() {
//       const blob = await fetch(this.path).then(r => r.blob());
//       return new Blob([blob], { type: this.mimeType });
//   }

//   private parseBase64(base64: string) {
//       this.safeUrl = base64;
//       this.isBase64 = true;
//   }

// }
// export class VideoSource {

//   mimeType: string;
//   filePath: string;
//   safeUrl: SafeResourceUrl;
//   fileName: string;
//   thumbPath: string;

//   constructor(videoSrc?: Partial<VideoSource>) {
//     Object.assign(this, videoSrc);

//     if (videoSrc.mimeType.includes('quicktime')) {
//       this.mimeType = 'video/mp4';
//     }
//     if (this.filePath.includes('http')) {
//       const idOf = this.filePath.lastIndexOf('.');
//       this.thumbPath = this.filePath.substring(0, idOf) + '.jpg';
//     }
//   }
// }
